import { createMediaMatcher } from "./createMediaMatcher";
import mediaDefaults from './mediaDefaults';
var defaultMedia = createMediaMatcher(mediaDefaults);
var pickMatch = defaultMedia.pickMatch;
var ProvideMediaMatchers = defaultMedia.Provider;
var MediaMatches = defaultMedia.Matches;
var InlineMediaMatcher = defaultMedia.Inline;
var MediaMatcher = defaultMedia.Matcher;
var Matches = defaultMedia.Matches;
var MediaMock = defaultMedia.Mock;
var Below = defaultMedia.Below;
var Above = defaultMedia.Above;
var MediaServerRender = defaultMedia.ServerRender;
var MediaConsumer = defaultMedia.Consumer;
var useMedia = defaultMedia.useMedia;
export { createMediaMatcher, pickMatch, ProvideMediaMatchers, MediaMatches, InlineMediaMatcher, Above, Below, MediaMatcher, MediaServerRender, Matches, MediaMock, MediaConsumer, useMedia, };
